import { addDays, format, isBefore, startOfDay } from 'date-fns';

export const toTimelessDateString = (date?: Date | null) => {
	if (!date) {
		return null;
	}

	return format(date, 'yyyy-MM-dd');
};

export const dateIsBeforeToday = (date: Date) => {
	return isBefore(startOfDay(date), startOfDay(new Date()));
};

export const dateIsBeforeTomorrow = (date: Date) => {
	return isBefore(startOfDay(date), startOfDay(addDays(new Date(), 1)));
};
